export class especificarAsunto {
  constructor() {
    this.subject = document.querySelector('select#asunto');
    this.fieldAsuntoEspecificar = document.querySelector('#field-asuntoEspecificar');

    if (!this.subject || !this.fieldAsuntoEspecificar) {
      return;
    }

    this.subject.addEventListener('change', this.onSubjectChange.bind(this) );

  }

  onSubjectChange(event) {
    
    let selectedOption = event.currentTarget.value.toLowerCase();
    
    if (selectedOption === 'otro') {
      console.log('aaaa');
      console.log(this.fieldAsuntoEspecificar);
      this.fieldAsuntoEspecificar.style.display = '';
      this.fieldAsuntoEspecificar.querySelector('input').focus();
    } else {
      this.fieldAsuntoEspecificar.style.display = 'none';
    }
  }
}